import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const DashboardProfile = ({ firstName = '', lastName = '' }) => {
  const { t } = useTranslation();
  return (
    <div className="dashboard-profile">
      <h4 className="fw-bold">Hi, {`${firstName} ${lastName}`}</h4>
      <Link to="/profile" className="">
        {t('dashboard.viewProfileInformation')}
      </Link>
    </div>
  );
};

export default DashboardProfile;

DashboardProfile.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};
